<template>
    <!--星/钻石/皇冠的显示-->
  <span class="star-box">
    <span class="colory" v-if="guanNum>0">{{guanNum}}<i class="el-icon-deythuangguan"></i></span>
    <span class="colorg" v-if="zhuanNum>0">{{zhuanNum}}<i class="el-icon-deythuiyuanzuanshi-xianxing"></i></span>
    <span class="coloro" v-if="starNum>0">{{starNum}}<i class="el-icon-deytxing_mian"></i></span>
  </span>
</template>

<script>
    export default {
        name: "star",
        props:{
          starTotalNum:{
            default:0,
            type:Number,
          }
        },
      data(){
          return{
            total:this.starTotalNum,
            zhuanNum:0,
            guanNum:0,
            starNum:0,
          }
      },
      mounted() {
      this.handleData()
      },
      methods:{
          //处理星星换钻换皇冠的方法，5颗星换一钻，5个钻换一个皇冠
          handleData(){
            this.guanNum=parseInt(this.total/25);
            this.zhuanNum=parseInt((this.total%25)/5);
            this.starNum=(this.total%25)%5
          }
      }
    }
</script>

<style lang="scss" scoped>
  .star-box{
    span{margin-left: 5px;font-size: 14px;width: 33%}
    i{margin-left: 5px}
    .colory{color: #FFDC00}
    .colorg{color: #50FF00}
    .coloro{color: #FFBF00}
  }

</style>



// WEBPACK FOOTER //
// src/pages/performance/components/star.vue